import React, { Component } from 'react'
import StagesManager from '../components/StagesManager';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import Responsive from '../components/Responsive';
import Header from '../components/header/Header';
import Cookies from 'universal-cookie';
import { chooseFontColor, conditionalWidth } from '../utils/useful';
import { DashboardSettings } from '../variables/AppletPages';
import DashboardView from '../components/views/DashboardView';
import CollectionView from './Applets/database/CollectionView';
import SettingsView from '../components/views/SettingsView';
import DiagramEditor from './Applets/database/stage/DiagramEditor';
import PageBuilder from './PageBuilder';
import FrameBuilder from './FrameBuilder';
import ProjectBuilder from './ProjectBuilder';
import HttpServices from '../utils/Http.services';

class Settings extends Component {

    state = {
        colors: {
            primaryColor: '#5856d6',
            secondaryColor: '#7c7aff',
            textColor: '#fff'
        },
        showBackBtn: false,
        showToolbar: true,
        headerConfig: {
            showToolbar: true, showSettings: false, showSettings: false,
            // showFrames: 'dashboardsSettings',
            title: `${this.props.user?.info?.fullname}`
        },
        modules: [],
        data: {},
        collapses: {},
        selectedAutomation: {},
    }

    componentDidMount() {
        // console.log('this.props.postDashboardvthis.props.postDashboard', this.props.data.postDashboard)
        const cookies = new Cookies();
        let token = cookies.get('token');
        if (token) {
            this.setState({ isLoading: true })
            this.waitForId(10)
        } else {
            this.setState({ pageStatus: 401 })
        }
        this.setHeader({
            'showToolbar': true,
            'showSettings': false,
            // 'showFrames': 'dashboardsSettings',
            'title': `${this.props.user?.info?.fullname}`,
        })
    }

    componentDidUpdate(prevProps) {
        if ((this.state.oldData && JSON.stringify(this.state.oldData) != JSON.stringify(this.props.windowData))) {
            this.setState({ oldData: this.props.windowData }, () => {
                this.checkDefaultTab()
            })
        }
        if (JSON.stringify(prevProps.data) != JSON.stringify(this.props.data)) {
            // console.log('prev', prevProps.data)
            // console.log('after', this.props.data)
        }
    }

    waitForId = (leftAttempt) => {
        if (this.props.user?.info?._id) {
            this.setState({ isLoading: false }, () => {
                let accessPages = Object.values(DashboardSettings.pages)
                let accessSections = Object.values(DashboardSettings.sections)
                this.setState({ modules: accessPages, sections: accessSections, oldData: this.props.windowData }, () => {
                    this.checkDefaultTab()
                })
            })
        } else {
            setTimeout(() => {
                if (leftAttempt != 0) {
                    this.waitForId(leftAttempt - 1)
                } else {
                    this.setState({ pageStatus: 401 })
                }
            }, 500);
        }
    }

    checkDefaultTab() {
        let def = ''
        let pageType = null
        let pageInfo = null
        let pathname = this.props.windowData?.path//window.location.pathname.split('/')
        let remainingPath = null
        let mindex = 1
        if (this.props.baseUrl) {
            mindex = this.props.baseUrl.length
        }
        def = pathname[mindex]
        // console.log('mindex', mindex)
        // console.log('pathname.length', pathname.length)
        remainingPath = pathname.slice(mindex, pathname.length)
        let pageIsValid = false
        let maxPathMatching = 0
        let maxPathVarMatching = 0
        Object.values(this.state.modules).forEach(page => {
            if (page.key) {
                // console.log('pagetypeeeeee1', pathname, def)
                let pageKey = null
                let defaultPage = page.defaultPage
                if (conditionalWidth(this.props.width, { xs: true, sm: false })) {
                    defaultPage = false
                }
                pageKey = page.key.split('/')
                // console.log('pagetypeeeeee2', pageKey.length, remainingPath)
                let tempMaxPathMatching = null
                let tempMaxPathVarMatching = null
                if (pageKey.length <= remainingPath.length) {
                    // console.log('pagetypeeeeee3')
                    for (let i = 0; i < pageKey.length; i++) {
                        let key = pageKey[i];
                        let remaining = remainingPath[i];
                        if (key == remaining || key == '[var]') {
                            tempMaxPathVarMatching = i
                            if (key == remaining) {
                                tempMaxPathMatching = i
                            }
                        }
                    }
                    if (tempMaxPathMatching != null && tempMaxPathMatching >= maxPathMatching) {
                        if (tempMaxPathVarMatching >= maxPathVarMatching) {
                            maxPathVarMatching = tempMaxPathVarMatching
                            maxPathMatching = tempMaxPathMatching
                            pageIsValid = true
                            pageType = page.pageType
                            pageInfo = page
                            def = page.key
                        }
                    }
                }
            }
        });
        if (!def) {
            def = ''
        }
        if (def === '') {
            pageType = ''
            pageIsValid = true
        }
        if (pageIsValid) {
            this.setState({ oldData: this.props.windowData }, () => {
                this.setState({ path: def, pageType }, () => {
                    setTimeout(() => {
                        this.setState({ page: null }, () => {
                            this.setState({ page: pageInfo, formPages: pageInfo?.formPages, headers: pageInfo?.headers, pageType, pageStatus: 200 }, () => {
                                // { console.log('pagetypeeeeee', pageType) }
                                if (this.stageManager) {
                                    if (this.stageManager) {
                                        this.stageManager.changeStage((pageType), () => {
                                            this.pageContainer.scrollTo({ top: 0, behavior: 'smooth' })
                                        })
                                    }
                                }
                            })
                        })
                    }, 10);
                })
            })
        } else {
            this.setState({ pageStatus: 404 })
        }
    }

    changeStage = (page) => {
        let path
        if (page) {
            path = ['settings', page?.key ?? page]
        }
        if ((page.key == 'newform' || page == 'newform') || (page.key == 'newPage' || page == 'newPage') || (page.key == 'automation' || page == 'automation')) {
            this.setState({ noSidebar: true })
        }
        this.props.changeWindowLink(path)
        this.stageManager.changeStage(path[1])
    }

    changeCollapse = (key) => {
        let collapses = this.state.collapses
        collapses[key] = this.state.collapses[key] == null ? true : !this.state.collapses[key]
        this.setState({ collapses })
    }

    changePage = (page) => {
        if (page == 'pages') {
            page = 'dashboards'
        }
        // console.log('hereeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeaddcha3', page)
        let extraPath
        let fullPath
        if (page != '') {
            extraPath = Array.isArray(page) ? page : [page]
            fullPath = [...this.props.baseUrl, ...extraPath]
        }
        else {
            fullPath = [...this.props.baseUrl]
        }

        // console.log('fullPathaa', fullPath)

        this.changeWindow(fullPath)
    }

    changeWindow = (list) => {
        console.log('list', list)
        if (Array.isArray(list)) {

            // let appletHub = typeof this.props.applet?.hub == 'object' ? this.props.applet?.hub?._id : this.props.applet?.hub

            // let variables = {
            //     appletId: this.props.applet?._id,
            //     appletHub: appletHub,
            //     username: this.props.applet?.hub?.username,
            //     appletSlug: this.props.applet?.slug
            // }


            let finalList = []
            list.forEach(value => {
                let one = value
                if (/\{\{(.*?)\}\}/.test(value)) {

                    if (this.props.variables) {
                        one = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                    }
                }
                if (one) {
                    finalList.push(one)
                }
            });

            // console.log(this.props.variables)

            console.log(finalList)
            // let type = finalList[0]
            // return
            this.props.changeWindow('', { path: finalList })
        }
    }

    onSave = (data, name, type) => {
        if (type == 'page') {
            this.submitPage(data, type)
        }
        else {
            this.nextStage(data, name)
        }
    }

    submitPage = (rawData, type) => {
        if (rawData) {
            let data = this.state.data
            data.page = rawData
            data.type = type
            this.setState({ data }, () => {
                HttpServices.request('postFrame', data, (fetchResult, fetchError) => {
                    if (fetchError) {
                        return
                    }
                })
            })
        }
    }

    submitCollection = () => {
        let data = this.state.data
        HttpServices.request('postFrame', data, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            this.props.lastStagePage()
        })
    }
    nextStage = (rawData, frameName) => {
        if (rawData && frameName.trim()) {
            let data = this.state.data
            data.frame = rawData
            data.name = frameName
            data.type = 'collection'
            this.setState({ data }, () => {
                this.stageManager.changeStage('frametype')
            })
        }
    }

    setData = (key, value, reference, cb) => {
        if (reference == 'SettingsSwitcher') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {
                })
            }
        }
    }

    lastStagePage = () => {
        this.props.removeWindowLink()
        this.setState({ noSidebar: false }, () => {
        })
    }

    functionsHandler = (type, name, data) => {
        if (type) {
            if (this[type] && this[type][name]) {
                this[type][name](data)
            }
        } else {
            if (this[name]) {
                this[name](data)
            }
        }
    }

    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: false,
                    // showFrames: 'dashboardsSettings',
                    title: `${this.props.user?.info?.fullname}`
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value, } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }
    postDashboard = (_id, name, pages, cb) => {
        if (this.props.data.postDashboard) {
            this.props.data.postDashboard(_id, name, pages, (fetchResult) => {
                cb(fetchResult)
            })
        }

    }
    render() {
        let colors = this.state.colors ?? {}
        if (!colors?.textColor) {
            colors.textColor = '#fff'
        }
        let iconInvert = chooseFontColor(colors.textColor) == '#fff' ? true : false
        colors.iconInvert = iconInvert
        colors.background = `linear-gradient(90deg, ${colors.primaryColor}, ${colors.secondaryColor})`
        return (
            <div className='d-flex w-100 h-100 window-content-radius ' style={{ display: 'block', backgroundColor: '#fff' }}>
                <div className="w-100  h-100  window-content-radius d-flex flex-column " ref={el => this.pageContainer = el} style={{}} >
                    <div className='w-100' style={{ position: 'relative', top: 0 }}>
                        <Header ref={el => this.header = el} config={this.state.headerConfig} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'dashboardsSettings'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.state.colors} />
                    </div>
                    <div className='d-flex w-100 h-100 scroll-no-scrollbar'>
                        {(conditionalWidth(this.props.width, { xs: false, sm: true }) || this.state?.page) && (
                            <Responsive width={this.props.width} media={{ xs: "12" }}>
                                <div className="w-100 h-100   window-content-radius " ref={el => this.pageContainer = el} style={{ backgroundColor: '#fff' }} >
                                    <StagesManager height={'100%'} className={'flex-1'} ref={el => this.stageManager = el} fast={true} >
                                        <DashboardView stage={0} stageName={''} language={this.props.language} colors={colors} windowData={this.props.windowData} lastStagePage={this.props.lastStagePage} applet={this.props.applet} pages={this.state?.pages} width={this.props.width} setData={this.setData} height={this.props.height} type={'Connections'} user={this.props.user} modules={this.state.modules} onClick={this.changePage} title={"Manage"} setHeader={this.setHeader} description={"Manage things and applets"} route={this.props.route} functionsHandler={this.functionsHandler} />
                                        <CollectionView stage={1} stageName={'dashboards'} baseUrl={[...this.props.baseUrl]} ref={el => this.collectionView = el} changePage={this.changePage} colors={colors} windowData={this.props.windowData} formPages={this.state.formPages} page={this.state.page} applet={this.props.applet} setData={this.setData} headers={this.state.headers} automations={this.state.automations} language={this.props.language} setHeader={this.setHeader} userSettings={this.state.userSettings} lastStagePage={this.lastStagePage} changeWindowLink={this.props.changeWindowLink} changeStage={this.changeStage} width={this.props.width} goToHub={this.props.goToHub} functionsHandler={this.functionsHandler} />
                                        <SettingsView stage={1} stageName={'config'} updateState={this.props.updateState} ref={el => this.collectionView = el} colors={colors} windowData={this.props.windowData} formPages={this.state.formPages} page={this.state.page} applet={this.props.applet} height={this.props.height} headers={this.state.headers} setData={this.setData} automations={this.state.automations} language={this.props.language} setHeader={this.setHeader} changePage={this.changePage} userSettings={this.state.userSettings} lastStagePage={this.lastStagePage} changeWindowLink={this.props.changeWindowLink} changeStage={this.changeStage} width={this.props.width} goToHub={this.props.goToHub} />
                                        <DiagramEditor stage={1} stageName={'automation'} frames={this.props.frames} language={this.props.language} baseUrl={[...this.props.baseUrl, 'automations']} setHeader={this.setHeader} colors={colors} windowData={this.props.windowData} page={this.state.page} automation={this.state.selectedAutomation} currentFrame={this.props.currentFrame} applet={this.props.applet} setData={this.setData} pages={this.state?.pages} width={this.props.width} height={this.props.height} type={'DiagramEditor'} user={this.props.user} modules={this.state.modules} changePage={this.changePage} title={"DiagramEditor"} description={"Manage things and applets"} route={this.props.route} functionsHandler={this.functionsHandler} selectedAutomation={this.state.selectedAutomation} headers={this.props.headers} />
                                        {/* <FormBuilder type={'newform'} language={this.props.language} setHeader={this.setHeader} colors={colors} windowData={this.props.windowData} page={this.state.page} initData={this.state.data.frame} collectionName={this.state.data.name} data={this.state.data} onSave={this.onSave} setData={this.setData} saveTitle='Next Step' applet={this.props.applet} pages={this.state?.pages} width={this.props.width} height={this.props.height}  user={this.props.user} modules={this.state.modules} stage={1} stageName={'newform'} changePage={this.changePage} title={"newform"} description={"Manage things and applets"} route={this.props.route} functionsHandler={this.functionsHandler} lastStagePage={this.lastStagePage} /> */}
                                        <PageBuilder stage={1} stageName={'pageBuilder'} baseUrl={[...this.props.baseUrl, 'dashboards']} actions={actions} type={'newpage'} title={"Page Builder"} language={this.props.language} setHeader={this.setHeader} changeWindowLink={this.props.changeWindowLink} changeWindow={this.changeWindow} setData={this.setData} colors={colors} windowData={this.props.windowData} page={this.state.page} initData={this.state.data.frame} collectionName={this.state.data.name} data={this.state.data} onSave={this.onSave} saveTitle='Next Step' applet={this.props.applet} pages={this.state?.pages} width={this.props.width} height={this.props.height} user={this.props.user} modules={this.state.modules} changePage={this.changePage} description={"Manage things and applets"} route={this.props.route} functionsHandler={this.functionsHandler} lastStagePage={this.lastStagePage} postDashboard={this.postDashboard} />
                                        <FrameBuilder stage={1} stageName={'frameBuilder'} baseUrl={[...this.props.baseUrl, 'frames']} actions={actions} type={'frameBuilder'} title={"Collection Builder"} language={this.props.language} setHeader={this.setHeader} changeWindowLink={this.props.changeWindowLink} changeWindow={this.changeWindow} setData={this.setData} colors={colors} windowData={this.props.windowData} page={this.state.page} initData={this.state.data.frame} collectionName={this.state.data.name} data={this.state.data} onSave={this.onSave} saveTitle='Next Step' applet={this.props.applet} pages={this.state?.pages} width={this.props.width} height={this.props.height} user={this.props.user} modules={this.state.modules} changePage={this.changePage} description={"Manage things and applets"} route={this.props.route} functionsHandler={this.functionsHandler} lastStagePage={this.lastStagePage} />
                                        <ProjectBuilder stage={1} stageName={'newproject'} baseUrl={[...this.props.baseUrl, 'newproject']} actions={actions} type={'newproject'} title={"Project Builder"} language={this.props.language} setHeader={this.setHeader} changeWindowLink={this.props.changeWindowLink} changeWindow={this.changeWindow} setData={this.setData} colors={colors} windowData={this.props.windowData} page={this.state.page} initData={this.state.data.frame} collectionName={this.state.data.name} data={this.state.data} onSave={this.onSave} saveTitle='Next Step' applet={this.props.applet} pages={this.state?.pages} width={this.props.width} height={this.props.height} user={this.props.user} modules={this.state.modules} changePage={this.changePage} description={"Manage things and applets"} route={this.props.route} functionsHandler={this.functionsHandler} lastStagePage={this.lastStagePage} />
                                    </StagesManager>
                                </div>
                            </Responsive>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Settings);
